<template>
    <!--SIGN UP PAGE-->
    <ThePageExternal :title="'SIGNUP__NEW_ACCOUNT'" 
                     :class-name="'SignUpView'">
        <!--WAITING FOR EMAIL CONFIRMAITION-->
        <template v-if="isEmailConfirmationPending">
            <div class="SignUpView__account-created">
                {{translate('SIGNUP__ACCOUNT_CREATED')}}
            </div>
            <div class="SignUpView__email-activity">
                <div class="SignUpView__email-activity_content">
                </div>
                <div class="SignUpView__email-activity-icon-container">
                    <i class="icon-mail SignUpView__email-activity-icon"></i>
                </div>
            </div>
            <div class="SignUpView__waiting-confirmation">
                {{translate('SIGNUP__WAITING_FOR_EMAIL_CONFIRMAITON')}}&nbsp;<span class="SignUpView__waiting-confirmation-email">{{email}}</span>...
            </div>
        </template>
        <!--SIGN UP FORM-->
        <template v-else>
            <div class="SignUpView__content">
                <div class="SignUpView__column">
                    <!--EMAIL-->
                    <BaseText :label="'SIGNUP__EMAIL'"
                              :value="email"
                              :errors="errors['email']"
                              :autofocus="true"
                              :icon="'icon-mail'"
                              @change="setEmail($event.target.value)" />

                    <!--PASSWORD-->
                    <BaseText :label="'SIGNUP__PASSWORD'"
                              :value="password"
                              :errors="errors['password']"
                              :icon="'icon-lock'"
                              :password="true"
                              @change="setPassword($event.target.value)" />

                    <!--CONFIRM PASSWORD-->
                    <BaseText :label="'SIGNUP__CONFIRM_PASSWORD'"
                              :value="confirmPassword"
                              :errors="errors['confirmPassword']"
                              :icon="'icon-cw-1'"
                              :password="true"
                              @change="setConfirmPassword($event.target.value)" />

                </div>
                <div class="SignUpView__column">
                    <!--NAME-->
                    <BaseText :label="'SIGNUP__NAME'"
                              :value="name"
                              :errors="errors['name']"
                              :icon="'icon-child'"
                              @change="setName($event.target.value)" />

                    <!--COMPANY NAME-->
                    <BaseText :label="'SIGNUP__COMPANY_NAME'"
                              :value="company"
                              :errors="errors['company']"
                              :icon="'icon-bank'"
                              @change="setCompany($event.target.value)" />

                    <!--TIMEZONE-->
                    <BaseDropdown :label="'SIGNUP__TIMEZONE'"
                                  :value="timezone"
                                  :items="timezones"
                                  :errors="errors['timezone']"
                                  :icon="'icon-clock'"
                                  @change="setTimezone($event.target.value)" />
                </div>
            </div>
            <div class="SignUpView__terms">
                <!--TERMS-->
                <BaseCheckbox :label="'SIGNUP__I_AGREE_TO'"
                              :value="termsAccepted"
                              :field-name="'termsAccepted'"
                              :errors="errors['termsAccepted']"
                              :link="termsLink"
                              :link-label="'SIGNUP__TO_TERMS_AND_CONDITIONS'"
                              @change="setTermsAccepted($event.target.checked)" />
            </div>
            <div class="SignUpView__actions">
                <!--BACK TO SIGN IN-->
                <BaseButtonFlat :label="'SIGNUP__TO_SIGN_IN'"
                                :class-name="'SignUpView__signin'"
                                @click="openSignIn()" />
                <!--SIGN UP-->
                <BaseButton :label="'SIGNUP__SIGN_UP'"
                            @click="signup($event.target)" />
            </div>
        </template>
    </ThePageExternal>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import ThePageExternal from '../components/common/ThePageExternal.vue';
    import BaseText from '../components/common/BaseText.vue';
    import BaseDropdown from '../components/common/BaseDropdown.vue';
    import BaseCheckbox from '../components/common/BaseCheckbox.vue';
    import BaseButton from '../components/common/BaseButton.vue';
    import BaseButtonFlat from '../components/common/BaseButtonFlat.vue';
    import constants from '../store/constants';

    export default {
        name: 'SignUpView',
        components: {
            ThePageExternal,
            BaseText,
            BaseDropdown,
            BaseCheckbox,
            BaseButton,
            BaseButtonFlat
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.load();
            });
        },
        computed: {
            ...mapState({
                isEmailConfirmationPending: s => s.signup.isEmailConfirmationPending,
                email: s => s.signup.email,
                password: s => s.signup.password,
                confirmPassword: s => s.signup.confirmPassword,
                name: s => s.signup.name,
                company: s => s.signup.company,
                timezone: s => s.signup.timezone,
                termsAccepted: s => s.signup.termsAccepted,
                errors: s => s.signup.errors,
                termsLink: s => 'https://example.com/terms'
            }),
            timezones: () => constants.timezones
        },
        methods: {
            ...mapActions({
                load: 'signup/load',
                openSignIn: 'signup/openSignIn',
                signup: 'signup/signup',

                //Setters
                setEmail: 'signup/setEmail',
                setPassword: 'signup/setPassword',
                setConfirmPassword: 'signup/setConfirmPassword',
                setName: 'signup/setName',
                setCompany: 'signup/setCompany',
                setTimezone: 'signup/setTimezone',
                setTermsAccepted: 'signup/setTermsAccepted',
            })
        }
    };
</script>

<style>
    .SignUpView {
        width: 720px;
        max-height: 463px;
    }

    .SignUpView__content {
        display: flex;
        flex-direction: row;
    }

    @media (min-width: 360px) and (max-width: 750px) {
        .SignUpView {
            max-height: 692px;
        }
    }

    @media (max-width: 750px) {
        .SignUpView {
            width: 360px;
        }

        .SignUpView__content {
            flex-direction: column;
        }
    }

    .SignUpView__column {
        width: 100%;
        display: flex;
        flex-direction: column;
        padding:0 8px;
    }

    .SignUpView__terms {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
    }

    .SignUpView__actions {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        padding: 20px 0;
    }

    .SignUpView__signin {
        font-size: 12px;
        margin-right: 16px;
        padding: 0;
    }

    .SignUpView__account-created {
        margin-bottom: 30px;
        font-size: 20px;
    }

    .SignUpView__email-activity {
        margin: 20px 0 50px 0;
    }

    .SignUpView__email-activity_content {
        width: 90px;
        height: 90px;
        margin: 0 auto;
        border: 10px solid rgba(0, 0, 0, 0.05);
        border-radius: 50%;
        border-left-color: rgba(0, 151, 167, 0.2);
        animation: email-spin 3000ms infinite linear;
    }

    @keyframes email-spin {
        100% {
            transform: rotate(360deg);
        }
    }

    @-webkit-keyframes email-spin {
        100% {
            transform: rotate(360deg);
        }
    }

    .SignUpView__email-activity-icon-container{
        margin-top:-75px;
        display:flex;
        flex-direction:row;
        justify-content:center;
        align-items:flex-start;
    }

    .SignUpView__email-activity-icon {
        font-size: 50px;
        color: #607D8B;
    }

    .SignUpView__waiting-confirmation {
        font-size: 20px;
        text-align:center;
        color: #37474F;
    }

    .SignUpView__waiting-confirmation-email {
        font-weight: 500;
        color: #00838F;
    }
</style>



// WEBPACK FOOTER //
// SignUpView.vue?5189b8d2